module.exports = __webpack_public_path__ + "static/media/OrangePeelposterAshevilleNC2010.3fb0e61c.webp";